import { ApiError } from '@/error-handler/types'

const TEST_ACCOUNT_EXPIRED_ERROR_CODE = 401007

export const includesTestAccountExpiredError = (errors: Array<ApiError>): boolean => {
    return errors.some(error => error.code === TEST_ACCOUNT_EXPIRED_ERROR_CODE)
}
